import { browserName, browserVersion, isAndroid, isChrome, isDesktop, isEdge, isFirefox, isIOS, isMacOs, isMobile, isMobileOnly, isOpera, isSafari, isTablet, mobileModel, osName, osVersion, } from 'react-device-detect';
// https://github.com/duskload/react-device-detect#readme
var isIPad = isTablet && isIOS;
var isIPhone = isMobileOnly && isIOS;
export var deviceDetection = {
    browserVersion: browserVersion,
    isIPad: isIPad,
    isIPhone: isIPhone,
    isAndroid: isAndroid,
    isIOS: isIOS,
    isMobile: isMobile,
    isMacOs: isMacOs,
    isDesktop: isDesktop,
    isChrome: isChrome || browserName === 'Chrome Headless',
    isOpera: isOpera,
    isSafari: isSafari,
    isFirefox: isFirefox,
    isEdge: isEdge,
    // Returns false if a tablet.
    isMobileOnly: isMobileOnly,
    // Windows, Android...
    osName: osName,
    // 7
    osVersion: osVersion,
    // Chrome, Safari...
    browserName: browserName,
    // Nexus 5
    mobileModel: mobileModel,
};
